export const LOG_IN_ROUTE = '/authentication/login';
export const HOME_ROUTE = '/home';
